import { Lightbulb, X } from "lucide-react";

import { Button } from "@/components/ui/Button";
import type { TBannerDefinition } from "@/lib/guidance/types";
import { useStore } from "@/store/store";

type TGuidanceBannerProps = {
  banner: TBannerDefinition;
  onCtaClick?: () => void;
};

export function GuidanceBanner({ banner, onCtaClick }: TGuidanceBannerProps) {
  const markBannerDismissed = useStore((state) => state.markBannerDismissed);

  const handleDismiss = () => {
    markBannerDismissed(banner.id);
  };

  return (
    <div
      className="mb-4 rounded-2xl border border-primary/20 bg-primary/5 p-4 shadow-sm"
      role="region"
      aria-label={banner.title}
    >
      <div className="flex items-start gap-3">
        <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
          <Lightbulb className="h-4 w-4" />
        </span>
        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-2">
            <h2 className="text-sm font-semibold text-foreground md:text-base">{banner.title}</h2>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="h-8 w-8 flex-shrink-0 p-0"
              onClick={handleDismiss}
              aria-label="Dismiss"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
          <p className="mt-1 text-xs leading-relaxed text-muted-foreground sm:text-sm">{banner.description}</p>
          {banner.ctaLabel && onCtaClick ? (
            <Button
              type="button"
              size="sm"
              className="mt-3"
              onClick={onCtaClick}
            >
              {banner.ctaLabel}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
